<h3 class="vc-title-s passwordRestore__title" i18n="@@LOGIN_MODAL.PASSWORD_RESET.TITLE">Forgotten Password</h3>
<div class="passwordRestore__wrapper">
  <div class="passwordRestore__form" [class.hidden]="submitted | async">
    <p i18n="@@LOGIN_MODAL.PASSWORD_RESET.TEXT">Enter your email. An email to reset your password will be sent.</p>
    <form [formGroup]="resetPasswordForm" [ngClass]="{hasLoader: pending | async}">
      <div class="form-group vc-form-text">
        <input
          type="email"
          id="useremail"
          formControlName="email"
          class="vc-form-text__input"
          [ngClass]="{notEmpty: currentEmail !== ''}"
          (blur)="onEmailFocusOut()"
        />
        <label for="useremail" class="vc-form-text__label">
          <div [hidden]="resetPasswordForm?.valid || resetPasswordForm.get('email').pristine">
            <span *ngIf="resetPasswordForm.get('email').errors?.required" i18n="@@LOGIN_MODAL.ERROR_REQUIRED_EMAIL"
              >Email is required</span
            >
            <span *ngIf="resetPasswordForm.get('email').errors?.pattern" i18n="@@LOGIN_MODAL.ERROR_PATTERN_EMAIL"
              >Incorrect email address</span
            >
            <span *ngIf="resetPasswordForm.get('email').errors?.unknownEmail">{{ errorMsg }}</span>
          </div>
          <span *ngIf="resetPasswordForm?.valid || resetPasswordForm.pristine"
            ><ng-container i18n="@@LOGIN_MODAL.EMAIL">Email</ng-container>*</span
          >
        </label>
      </div>
      <button
        type="button"
        (click)="resetPassword()"
        class="vc-btn vc-btn--primary vc-btn__large vc-btn__full passwordRestore__submit"
        [disabled]="(pending | async) || !resetPasswordForm.valid"
        i18n="@@LOGIN_MODAL.PASSWORD_RESET.CONFIRM_BTN"
      >
        Confirm
      </button>
    </form>
  </div>
  <div class="passwordRestore__confirmation">
    <p class="passwordRestore__confirmationTxt" i18n="@@LOGIN_MODAL.PASSWORD_RESET.CONFIRMATION">
      We've just sent you an email containing the password reset procedure.
    </p>
    <button
      class="vc-btn vc-btn--primary vc-btn--large vc-btn--full passwordRestore__continue"
      (click)="continueAfterConfirmation()"
      i18n="@@LOGIN_MODAL.PASSWORD_RESET.CONTNUE_BTN"
    >
      Continue
    </button>
  </div>
</div>
